//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataProfilingStepsService from '@/apps/data-platform/services/data_quality/data_profiling_steps_service';
export default {
  name: 'ProfilingExecuteError',
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isSubmitting: false
    };
  },
  methods: {
    executeError: function executeError(type, process) {
      var params = {
        domainTable: this.item.domainTable,
        documentId: this.item.document_id,
        executionType: type,
        profilingProcess: process
      };
      DataProfilingStepsService.executeDataProfiling(params);
      this.onCancel();
    },
    onCancel: function onCancel() {
      this.$emit('closeExecuteError');
    }
  }
};